export const EXCLUDED_DIRECTIONS = {
  11: {
    'null-null-[]': true,
  },
  13: {
    '46-null-[]': true,
    '47-null-[]': true,
  },
  15: {
    'None-null-[]': true,
    '13-null-[]': true,
    '10-null-[]': true,
  },
  16: {
    '10-null-[]': true,
    '47-3-[426]': true,
    '47-1-[426]': true,
    'null-null-[]': true,
  },
  17: {
    '46-6-[]': true,
    '24-3-[]': true,
    '47-4-[426]': true,
  },
  21: {
    'null-3-[]': true,
  },
  23: {
    'null-null-[]': true,
  },
  24: {
    '47-3-[423]': true,
    '47-14-[423]': true,
    '47-4-[]': true,
  },
  25: {
    'null-null-[]': true,
  },
  27: {
    '10-null-[]': true,
  },
  30: {
    '2-null-[]': true,
  },
  33: {
    '1-null-[]': true,
  },
  35: {
    '4-11-[24,277]': true,
    '4-39-[24,277]': true,
    '4-1-[24,277]': true,
    '4-18-[24,277]': true,
  },
  36: {
    '3-null-[]': true,
    '58-null-[]': true,
    'null-null-[]': true,
  },
  37: {
    '13-null-[]': true,
  },
  40: {
    '13-null-[]': true,
    '10-null-[]': true,
    '47-1-[428]': true,
    '4-1-[]': true,
    '19-3-[]': true,
    'null-null-[]': true,
  },
  43: {
    '46-4-[]': true,
    '16-1-[]': true,
  },
  44: {
    '37-3-[]': true,
    '13-null-[]': true,
  },
  53: {
    '10-null-[]': true,
    '41-null-[]': true,
  },
  57: {
    '47-4-[]': true,
    '47-3-[423]': true,
    '47-14-[423]': true,
  },
  58: {
    'null-null-[]': true,
  },
  62: {
    '7-null-[]': true,
    '41-null-[]': true,
    '12-null-[]': true,
  },
  65: {
    '13-null-[]': true,
  },
  66: {
    '47-null-[]': true,
    '58-null-[]': true,
    '4-null-[]': true,
    'null-null-[]': true,
    'null-39-[277]': true,
  },
  78: {
    '13-null-[]': true,
    '41-1-[]': true,
  },
  80: {
    'null-null-[]': true,
  },
  85: {
    '31-null-[]': true,
    '37-null-[]': true,
  },
  90: {
    '20-58-[]': true,
    '15-58-[]': true,
    '8-58-[]': true,
    '2-58-[]': true,
    '21-58-[]': true,
  },
  96: {
    'null-null-[]': true,
  },
  127: {
    '4-1-[]': true,
    '4-5-[]': true,
  },
  131: {
    '78-79-[]': true,
    'null-null-[]': true,
  },
};